const styles = () => ({
  table: {
    minWidth: 650
  },
  imageContainer: { height: 60, width: 'auto' },
  image: { maxWidth: '100%', maxHeight: '100%' }
});

export default styles;
